import { TableFooter, TableFooterProps } from "@mui/material";
import { forwardRef } from "react";

export type SHTableFooterProps = TableFooterProps;
export const SHTableFooter = forwardRef(
  (props: SHTableFooterProps, ref: any): JSX.Element => (
    <TableFooter {...props} ref={ref} />
  ),
);
